// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import logo from "../../../../assets/images/hero.png";
import user from "../../../../assets/images/user.png";
import { RouteComponentProps } from "react-router-dom";
import { IAuthenticationState, IApplicationState,IChepIdList,IMChepIdList } from "../../../../models/applicationState";
import IAuthenticationActions, * as authenticationActions from "../../../../redux/actions/authenticationActions";
import { booleanMaskAsync } from "@tensorflow/tfjs";

/**
 * Side bar that remains visible throughout app experience
 * Contains links to editor, settings, export, etc.
 * @param param0 - {
 *      project - IProject
 * }
 */


export interface IHeaderProps extends RouteComponentProps, React.Props<Header> {
    loggedUser?: IAuthenticationState;
    authenticationActions?: IAuthenticationActions;
}

function mapStateToProps(state: IApplicationState) {
    return {
        loggedUser: state.loggedInUser,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        authenticationActions: bindActionCreators(authenticationActions, dispatch),
    };
}


export interface IHeaderState {
    headersList: any[];
    headersBList: any[];
    headersMList:any[];
    adminheadersList:any[];
    headersCList:any[];
}

@connect(mapStateToProps, mapDispatchToProps)

class Header

    extends React.Component<IHeaderProps, IHeaderState> {
    public state: IHeaderState = {
        headersList: [
            { name: " Create Model", path: "/create-model", active: "", fontClass: "fa fa-plus bg-color-1" },
            { name: " My Models", path: "/my-models", active: "", fontClass: "fa fa-th bg-color-1" },
            { name: " Operations", path: "/operations/projects", active: "", fontClass: "fa fa-cog bg-color-1" },
            { name: " Performance Metrics", path: "/dashboardpb", active: "", fontClass: "fa fa-tachometer-alt bg-color-1" },
           // { name: "  invoice Management", path: "/invoiceManagement", active: "", fontClass: "fa fa-file bg-color-1" },
            { name: "  Document Management", path: "/DocumentManagement", active: "", fontClass: "fa fa-file bg-color-1" },
            { name: "  Order Management", path: "/OrderManagement", active: "", fontClass: "fa fa-file bg-color-1" },
            //{ name: "  Admin", path: "/Admin", active: "", fontClass: "fa fa-file bg-color-1" },
      
            //{ name: " Performance Metrics", path: "/dashboard", active: "", fontClass: "fa fa-tachometer-alt bg-color-1" },
        ],
        adminheadersList: [
            { name: " Create Model", path: "/create-model", active: "", fontClass: "fa fa-plus bg-color-1" },
            { name: " My Models", path: "/my-models", active: "", fontClass: "fa fa-th bg-color-1" },
            { name: " Operations", path: "/operations/projects", active: "", fontClass: "fa fa-cog bg-color-1" },
            { name: " Performance Metrics", path: "/dashboardpb", active: "", fontClass: "fa fa-tachometer-alt bg-color-1" },
           // { name: "  invoice Management", path: "/invoiceManagement", active: "", fontClass: "fa fa-file bg-color-1" },
            { name: "  Document Management", path: "/DocumentManagement", active: "", fontClass: "fa fa-file bg-color-1" },
            { name: "  Order Management", path: "/OrderManagement", active: "", fontClass: "fa fa-file bg-color-1" },
            { name: "  Admin", path: "/Admin", active: "", fontClass: "fa fa-file bg-color-1" },
      
            //{ name: " Performance Metrics", path: "/dashboard", active: "", fontClass: "fa fa-tachometer-alt bg-color-1" },
        ],
        
        
        
        headersBList: [
          
            { name: "  Document Management", path: "/DocumentManagement", active: "", fontClass: "fa fa-file bg-color-1" },
            { name: " Performance Metrics", path: "/dashboardpb", active: "", fontClass: "fa fa-tachometer-alt bg-color-1" },
            //{ name: " Performance Metrics", path: "/dashboard", active: "", fontClass: "fa fa-tachometer-alt bg-color-1" },
        ],
        headersMList: [
          
            { name: "  Document Management", path: "/DocumentManagement", active: "", fontClass: "fa fa-file bg-color-1" },
            { name: " Performance Metrics", path: "/dashboardpb", active: "", fontClass: "fa fa-tachometer-alt bg-color-1" },
            { name: "  Order Management", path: "/OrderManagement", active: "", fontClass: "fa fa-file bg-color-1" },
            //{ name: " Performance Metrics", path: "/dashboard", active: "", fontClass: "fa fa-tachometer-alt bg-color-1" },
        ],
        headersCList:[]
    }
    // const history = useHistory();
    // const signInUserSession = localStorage.getItem("signInUserSession");
    // const this.props.loggedUser && this.props.loggedUser = signInUserSession && JSON.parse(signInUserSession);
    // const logout = () => {
    //     localStorage.clear();
    //     history.push("/login");
    // };

    public async componentDidMount() {
       // debugger;
        let userEmail=this.props.loggedUser.user.emails[0];
        let pathname = this.props.history.location["pathname"];
        
        let chepidList=IChepIdList;
        
        //if(userEmail.toLocaleLowerCase()=== "vijayak.in@mouritech.com")
        /*
        if(chepidList.indexOf(userEmail.toLocaleLowerCase())>-1)
        {
        if((pathname.indexOf("DocumentManagement")>-1)||(pathname.indexOf("editTagsData_for_Document")>-1)
        ||(pathname.indexOf("dashboardpb")>-1)||(pathname.indexOf("profile")>-1)||(pathname.indexOf("change-password")>-1)) 
        {
            
        }
        else
        {
           this.logout();
        }
    }*/
        
      //  debugger;
        //build header based on features -start
        //get the users
        let chepRole:any = localStorage.getItem("ChepRole");
        if(chepRole==="C")
        {
            //get list of features
            let featuresList:[] =JSON.parse(localStorage.getItem("ChepFeatures"));
            let cHeaderList:any[]=[];
            for (let i=0;i<featuresList.length;i++)
            {
                if(featuresList[i]==="MY_MODELS")
                {
                    cHeaderList.push(
                    { name: " Create Model", path: "/create-model", active: "",
                     fontClass: "fa fa-plus bg-color-1" });
                    cHeaderList.push(                        
                        { name: " My Models", path: "/my-models", active: "", 
                        fontClass: "fa fa-th bg-color-1" });
                }
                else if (featuresList[i]==="OPERATIONS")
                {
                    cHeaderList.push(
                        { name: " Operations", path: "/operations/projects", active: "", fontClass: "fa fa-cog bg-color-1" }
                        );
                }
                else if (featuresList[i]==="PERFORMANCE_METRICS")
                {     cHeaderList.push(
                        { name: " Performance Metrics", path: "/dashboardpb", active: "", fontClass: "fa fa-tachometer-alt bg-color-1" }
                        );
                }
                else if (featuresList[i]==="DOCUMENT_MANAGEMENT")
                {
                    cHeaderList.push(
                        { name: "  Document Management", path: "/DocumentManagement", active: "", fontClass: "fa fa-file bg-color-1" }
                        );
                }              
                else if (featuresList[i]==="ORDER_MANAGEMENT")
                {
                    cHeaderList.push(
                        { name: "  Order Management", path: "/OrderManagement", active: "", fontClass: "fa fa-file bg-color-1" }
                        );
                      
                }
                else if (featuresList[i]==="ADD_USER")
                {
                    // cHeaderList.push(
                    //     { name: "  Admin", path: "/Admin", active: "", fontClass: "fa fa-file bg-color-1" }
                    //     );
                    cHeaderList.push(
                            { name: "Add User", path: "/register", active: "", fontClass: "fa fa-file bg-color-1" }
                        );
                }
            }
            
            this.setState({headersCList:cHeaderList});
            
        }
      
        //build header based on features -end      
        
        
    
        
    }
    
    private getTabs_old(){
        let userEmail=this.props.loggedUser.user.emails[0];   
        let pathname = this.props.history.location["pathname"];
        if(IChepIdList.indexOf(userEmail.toLocaleLowerCase())>-1){
            return   <ul className="navbar-nav nav" id="navigation" >
                                                                          
            {this.state.headersBList && this.state.headersBList.map((header, index) => {
                header.active = header.path === this.props.history.location["pathname"] ? "active" : "";
                if (this.props.history.location["pathname"]) {
                    if (index === 0) {
                        //
                        if((pathname.indexOf("DocumentManagement")>-1)||(pathname.indexOf("editTagsData_for_Document")>-1))
                           
                        {
                        header.active =   "active"  ;
                        }
                    } else if (index === 2) {
                        //header.active =   "active"  ;
                        if((pathname.indexOf("dashboardpb")>-1))                                                   
                        {
                        header.active =   "active"  ;
                        }
                    }
                }
                return (
                    <li className="nav-item " key={index}>
                        <Link className={`nav-link ${header.active}`}
                            title={header.name} to={header.path} role="button">
                            <i className={header.fontClass}
                                aria-hidden="true"></i>
                            <span className=""> {header.name}</span>
                        </Link>
                    </li>
                );
            })}
            
            
        </ul>
        }
        else if(IMChepIdList.indexOf(userEmail.toLocaleLowerCase())>-1){
            return   <ul className="navbar-nav nav" id="navigation" >
                                                                          
            {this.state.headersMList && this.state.headersMList.map((header, index) => {
                header.active = header.path === this.props.history.location["pathname"] ? "active" : "";
                if (this.props.history.location["pathname"]) {
                    console.log(pathname,index)
                    if (index === 0) {
                        //
                        if((pathname.indexOf("DocumentManagement")>-1)||(pathname.indexOf("editTagsData_for_Document")>-1))
                           
                        {
                        header.active =   "active"  ;
                        }
                    } else if (index === 1) {
                        //header.active =   "active"  ;
                        if((pathname.indexOf("dashboardpb")>-1))                                                   
                        {
                            console.log(pathname,index)
                        header.active =   "active"  ;
                        }
                    }
                    else if (index === 2) {
                        //header.active =   "active"  ;
                        if((pathname.indexOf("OrderManagement")>-1))                                                   
                        {
                        header.active =   "active"  ;
                        }
                    }
                }
                return (
                    <li className="nav-item " key={index}>
                        <Link className={`nav-link ${header.active}`}
                            title={header.name} to={header.path} role="button">
                            <i className={header.fontClass}
                                aria-hidden="true"></i>
                            <span className=""> {header.name}</span>
                        </Link>
                    </li>
                );
            })}
            
            
        </ul>
        }
        else{
         return   <ul className="navbar-nav nav" id="navigation" style={{ fontSize:'9px' }}>
                                                                          
            {this.state.headersList && this.state.headersList.map((header, index) => {
                header.active = header.path === this.props.history.location["pathname"] ? "active" : "";
                if (this.props.history.location["pathname"]) {
                    if (index === 0) {
                        header.active = ((index === 0 && (this.props.history.location.pathname.split("/")[1] === "projects"))
                            || (index === 0 && (this.props.history.location.pathname.split("/")[1] === "upload-files"))
                            || this.props.history.location.pathname.split("/")[1] === "create-model") ? "active" : "";
                    } else if (index === 2) {
                        header.active = (index === 2 && (this.props.history.location.pathname.split("/")[1] === "operations")) ? "active" : "";
                    }
                }
                return (
                    <li className="nav-item " key={index}>
                        <Link className={`nav-link ${header.active}`}
                            title={header.name} to={header.path} role="button">
                            <i className={header.fontClass}
                                aria-hidden="true"></i>
                            <span className=""> {header.name}</span>
                        </Link>
                    </li>
                );
            })}
            
            
        </ul>

        }
    }
    private getTabs(){
       // debugger;
        let userEmail=this.props.loggedUser.user.emails[0];   
        let pathname = this.props.history.location["pathname"];
        
        //get role from Local storage
        let chepRole:any = localStorage.getItem("ChepRole");
        
        let isAdmin;
       // debugger;
        if (this.props.loggedUser) {
            isAdmin = (this.props.loggedUser.user.extension_role === "ROLE_SUPPORT_ADMIN") ? true : false;
        }
        
        
       if(chepRole==="C"){
            return   <ul className="navbar-nav nav" id="navigation" >                                                                          
            {this.state.headersCList && this.state.headersCList.map((header, index) => {
                header.active = header.path === this.props.history.location["pathname"] ? "active" : ""; 
                return (
                    <li className="nav-item " key={index}>
                        <Link className={`nav-link ${header.active}`}
                            title={header.name} to={header.path} role="button">
                            <i className={header.fontClass}
                                aria-hidden="true"></i>
                            <span className=""> {header.name}</span>
                        </Link>
                    </li>
                );
            })}
            
            
        </ul>
        }  
        else if(isAdmin)
        {
         return ( 
          <ul className="navbar-nav nav" id="navigation" style={{ fontSize:'9px' }}>                                                                          
            {this.state.adminheadersList && this.state.adminheadersList.map((header, index) => {
                header.active = header.path === this.props.history.location["pathname"] ? "active" : "";
                if (this.props.history.location["pathname"]) {
                    if (index === 0) {
                        header.active = ((index === 0 && (this.props.history.location.pathname.split("/")[1] === "projects"))
                            || (index === 0 && (this.props.history.location.pathname.split("/")[1] === "upload-files"))
                            || this.props.history.location.pathname.split("/")[1] === "create-model") ? "active" : "";
                    } else if (index === 2) {
                        header.active = (index === 2 && (this.props.history.location.pathname.split("/")[1] === "operations")) ? "active" : "";
                    }
                }
                return (
                    <li className="nav-item " key={index}>
                        <Link className={`nav-link ${header.active}`}
                            title={header.name} to={header.path} role="button">
                            <i className={header.fontClass}
                                aria-hidden="true"></i>
                            <span className=""> {header.name}</span>
                        </Link>
                    </li>
                );
            })}           
            
        </ul>);

        }      
        else
        {
         return ( 
          <ul className="navbar-nav nav" id="navigation" style={{ fontSize:'9px' }}>                                                                          
            {this.state.headersList && this.state.headersList.map((header, index) => {
                header.active = header.path === this.props.history.location["pathname"] ? "active" : "";
                if (this.props.history.location["pathname"]) {
                    if (index === 0) {
                        header.active = ((index === 0 && (this.props.history.location.pathname.split("/")[1] === "projects"))
                            || (index === 0 && (this.props.history.location.pathname.split("/")[1] === "upload-files"))
                            || this.props.history.location.pathname.split("/")[1] === "create-model") ? "active" : "";
                    } else if (index === 2) {
                        header.active = (index === 2 && (this.props.history.location.pathname.split("/")[1] === "operations")) ? "active" : "";
                    }
                }
                return (
                    <li className="nav-item " key={index}>
                        <Link className={`nav-link ${header.active}`}
                            title={header.name} to={header.path} role="button">
                            <i className={header.fontClass}
                                aria-hidden="true"></i>
                            <span className=""> {header.name}</span>
                        </Link>
                    </li>
                );
            })}           
            
        </ul>);

        }
    }
    public render() {
        console.log(this.props.loggedUser.user.extension_role)
       // debugger;
        let chepidList=IChepIdList;
        let register;
        if (this.props.loggedUser) {
            register = (this.props.loggedUser.user.extension_role === "ROLE_SUPPORT_ADMIN"
                || this.props.loggedUser.user.extension_role === "ROLE_ADMIN") ? true : false;
        }
        let userEmail=this.props.loggedUser.user.emails[0];        
        let ischepId:boolean = chepidList.indexOf(userEmail.toLocaleLowerCase())>-1?true:false;
        let pathname = this.props.history.location["pathname"];
        return (
            <>
                <header className="main-header">
                    <nav className="navbar navbar-expand-md bg-dark fixed-top  navbar-dark">
                        <div className="container-fluid">
                            <a className="navbar-brand" href="#">
                                <img src={logo} className="img-fluid logo" />
                            </a>
                            <button className="navbar-toggler" type="button" data-toggle="collapse"
                                data-target="#collapsibleNavbar">
                                <span className="navbar-toggler-icon"></span>
                            </button>
                            <div className="collapse navbar-collapse" id="collapsibleNavbar">
                            {this.getTabs()} 
                            </div>

                            <div className="justify-content-end">
                                <ul className="navbar-nav nav  user-login" id="navigation">
                                    {/* <li className="nav-item text-right">
                            <span className="nav-link text-uppercase text-white">{basedActiveShowProjectName && localStorage.getItem("project_name")}</span>
                            </li> */}
                                    <li className="dropdown">
                                        <a className="user cursor-pointer" role="button" id="navbardrop" data-toggle="dropdown">
                                            <div className="user_name tex-right" title={`${this.props.loggedUser.user.given_name}`}>{this.props.loggedUser && this.props.loggedUser.user.given_name}</div>
                                        
                                         
                                        <span className="user-icon1">
                                                <img className="rounded1"   />
                                            </span>
                                             
                                            
                                            
                                        </a>
                                        <div className="dropdown-menu dropright">
                                            <Link className=" user-item" title={"Profile"} to="/profile" role="button">
                                                <i className="fa fa-user" aria-hidden="true"></i>Profile</Link >
                                            {/* {register &&
                                                <Link className=" user-item" title={"Add User"} to="/register" role="button">
                                                    <i className="fa fa-user-plus" aria-hidden="true"></i>Add User</Link >} */}
                                            <a className="user-item cursor-pointer "
                                                title={"Login"} onClick={() => this.logout()} role="button">
                                                <i className="fa fa-power-off" aria-hidden="true"></i>Sign Out</a >
                                            {/* <a className=" user-item" title={"Logout"} to="/login" role="button"> <i className="fa fa-power-off" aria-hidden="true"></i>Sign Out</Link > */}
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </nav>
                </header>
            </>
        );
    }

    private logout = () => {
        // localStorage.clear();
        this.props.authenticationActions.userLoggedOut();
        this.props.history.push("/login");
        // window.location.reload();
    }
}

export default Header;
